// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".template-search-empty-state--WmqfU .empty-state-content--LJojX{max-width:400px}.template-search-empty-state--WmqfU .empty-state-icon--_445U{color:#b4bccd;font-size:64px}.template-search-empty-state--WmqfU .empty-state-title--HUCeI{color:#24282f}.template-search-empty-state--WmqfU .empty-state-description--RWPkT{color:#798294}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"template-search-empty-state": "template-search-empty-state--WmqfU",
	"empty-state-content": "empty-state-content--LJojX",
	"empty-state-icon": "empty-state-icon--_445U",
	"empty-state-title": "empty-state-title--HUCeI",
	"empty-state-description": "empty-state-description--RWPkT"
};
export default ___CSS_LOADER_EXPORT___;
